import { SuggestionType } from '@/modules/investments/types/suggestion';
import {
  getInvestmentSuggestions,
  IInvestmentSuggestion
} from '@/modules/wealth/services/investment';
import { apolloClient } from '@/modules/common/services/graphql/apollo-client';
import {
  GlobalSummaryPortfolioSuggested,
  OverViewPortfolioSuggestedDetailsDocument,
  OverViewPortfolioSuggestedDetailsQuery,
  OverViewPortfolioSuggestedListDocument,
  OverViewPortfolioSuggestedListQuery
} from '@/modules/common/services/graphql/server/server.sdk';
import { ApolloQueryResult } from '@apollo/client';
import {
  BffWithdraw,
  IRedemptionPreviewPayload,
  IRedemptionSuggestionData
} from '@/modules/wealth/services/withdraw';

interface ISuggestionHandlerParams {
  onInvestment: () => unknown;
  onDefault: () => unknown;
  onRedeem?: () => unknown;
}

export async function handleSuggestionType(
  type: SuggestionType,
  { onInvestment, onDefault, onRedeem }: ISuggestionHandlerParams
) {
  switch (type) {
    case SuggestionType.Investment:
      return await onInvestment();
    case SuggestionType.Redeem:
      return await onRedeem?.();
    default:
      return await onDefault();
  }
}
const bffWithdraw = new BffWithdraw();

export const getInvestmentSuggestionsList = async (customerId: string) => {
  const data = await getInvestmentSuggestions(customerId);
  return {
    investmentList: data.getInvestmentSuggestions
  };
};

export const getWalletSuggestionsList = async () => {
  const { data }: ApolloQueryResult<OverViewPortfolioSuggestedListQuery> =
    await apolloClient.query({
      query: OverViewPortfolioSuggestedListDocument
    });
  return {
    walletList: data.globalSummary
      ?.suggestedPortfolios as GlobalSummaryPortfolioSuggested[]
  };
};

export const getWalletSuggestionDetail = async (portfolioId: string) => {
  const { data }: ApolloQueryResult<OverViewPortfolioSuggestedDetailsQuery> =
    await apolloClient.query({
      query: OverViewPortfolioSuggestedDetailsDocument,
      variables: { portfolioId }
    });
  return data.globalSummary!.suggestedPortfolioDetails;
};

export const getRedeemSuggestions = async () => {
  const { acceptanceListToRedeem } = await bffWithdraw.getRedeemSuggestions();
  return {
    redeemList: acceptanceListToRedeem.data
  };
};

export const getRedeemSuggestionDetail = async (
  customerId: string,
  redeemData: IRedemptionSuggestionData
): Promise<Partial<IInvestmentSuggestion>> => {
  const redemptionPreviewPayload: IRedemptionPreviewPayload = {
    customerId,
    portfolioId: redeemData.portfolio.id,
    products: redeemData.products.map(product => ({
      amount: product.amount,
      instrumentDetailApiId: product.productApiId
    })),
    validation: false
  };

  const data = await bffWithdraw.redemptionPreview(redemptionPreviewPayload);
  return {
    name: 'Sugestão de resgate',
    transactionId: redeemData.transactionId,
    portfolioName: data.redemptionPreview.portfolio.name,
    createdAt: redeemData.createdAt,
    amount: data.redemptionPreview.summaryPreview.grossValue,
    products: data.redemptionPreview.products.map(product => ({
      productApiId: product.id,
      productName: product.name,
      amount: product.grossValue
    }))
  };
};
